import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'sp-add-cinc-credential',
  templateUrl: './add-cinc-credential.component.html',
  styleUrls: ['./add-cinc-credential.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddCincCredentialComponent {
  @Input() formGroup: FormGroup;
}
